import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    // flexDirection: 'column',
    backgroundColor: 'white',
    height: '100%'
  },
  section: {
    margin: "10px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  detailsSection: {
    display: "flex",
    flexDirection: 'column',
    gap: "25px 0px",
    marginTop: "20px"


  },
  container: {
    display: "flex",
    flexDirection: "row",
    // alignItems: 'flex-start'
    alignItems: 'center',
    justifyContent: 'center'

  },

});
const reportStyles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

  },
  text: {
    textAlign: "center",
    wordWrap: "break-word",
    maxWidth: "100%",
    fontSize: "12px",
  }
});




// Create Document Component
const ProposalFormat = ({ data }) => (
  <Document>

    <Page size="A4" style={styles.page}>
      {/* Image */}
      <View style={styles.section}>
        <Text style={{ marginTop: 20, color: '#000000', fontWeight: 'bold', fontSize: 12 }}>{data}</Text>
        {/* <View className={reportStyles.container}>
          <Text className={reportStyles.text}>{data.techstack}</Text>
        </View> */}
       
      </View>
     
    </Page>

    
  </Document>
);

export default ProposalFormat;
